import React from "react";
import Image from "next/image";
import Link from "next/link";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";
import styled from "styled-components";

type IProps = {
    id?: string | undefined;
    image?: string;
    title?: string;
    date?: string;
    content?: string;
    link?: string;
}

const SuccessStory = (props: IProps) => {
    return (
      <SuccessStoryWrapper id={props.id}>
          <div className="success-story-container">
              {props.image && (
                  <div className="success-story-img">
                      <div>
                          <Image
                            alt={"Pembe Panjur"}
                            src={`${props.image}`}
                            loading={"lazy"}
                            fill
                            sizes="(max-width: 768px) 100vw,
                                (max-width: 1200px) 50vw,
                                33vw"
                            style={{
                                objectFit: "cover",
                                borderRadius: "10px",
                            }}
                            className={'image'}
                          />
                      </div>
                  </div>
              )}
              <div className="success-story-detail">
                  {props.title && (
                      <div className="success-story-title">
                          {props.title}
                      </div>
                  )}
                  {props.date && (
                      <div className="success-story-date">
                          {props.date}
                      </div>
                  )}
                  {props.content && (
                      <div className="success-story-content">
                          {props.content}
                      </div>
                  )}
                  {props.link && (
                      <div className="success-story-link">
                          <Link href={`${props.link}`} key={Math.random()}>
                              Hikayeyi oku
                          </Link>
                      </div>
                  )}
              </div>
          </div>
      </SuccessStoryWrapper>
    );
}

const SuccessStoryWrapper = styled.div`
  position: relative;
  margin-top: 26px;
  box-sizing: border-box;
  padding: 0 24px;

  &:last-child {
    margin-bottom: 30px;

    @media ${deviceMax.tablet} {
      margin-bottom: 0;
    }
  }

  > .success-story-container {
    position: relative;
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    margin: 0 auto;
    background: ${Colors.white};
    border-radius: 6px;

    @media ${deviceMax.tablet} {
      flex-direction: column;
    }

    > .success-story-img {
      flex: 1.5;
      margin-right: 38px;

      @media ${deviceMax.tablet} {
        margin-right: 0;
      }

      > div {
        position: relative;
        width: 100%;
        height: 100%;

        @media ${deviceMax.tablet} {
          height: 315px;
        }

        > span {
          position: unset !important;
          background-color: ${Colors.white};
          border: 0.5px solid rgba(0, 0, 0, 0.1);
          border-radius: 6px 0 0 6px;

          .image {
            object-fit: contain;
            width: 100% !important;
            height: unset !important;

            @media (min-width: 769px) {
              object-fit: cover;
            }
          }
        }
      }
    }

    > .success-story-detail {
      flex: 4;
      padding-right: 45px;

      @media ${deviceMax.tablet} {
        padding-right: 25px;
        padding-left: 25px;
      }

      > .success-story-title {
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0;
        color: ${Colors.blackColor};
        margin-bottom: 17px;
        margin-top: 40px;

        @media ${deviceMax.tablet} {
          margin-bottom: 10px;
          text-align: center;
          font-size: 18px;
        }
      }

      > .success-story-date {
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0;
        color: ${Colors.purpleColor};
        margin-bottom: 17px;

        @media ${deviceMax.tablet} {
          text-align: center;
        }
      }

      > .success-story-content {
        font-family: 'Manrope', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 0;
        color: ${Colors.blackColor};
        margin-bottom: 25px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow:hidden;

        @media ${deviceMax.tablet} {
          text-align: center;
          font-size: 16px;
          line-height: 24px;
        }
      }

      > .success-story-link {
        margin-bottom: 25px;

        @media ${deviceMax.tablet} {
          text-align: center;
        }

        > a {
          display: inline-block;
          font-family: 'Manrope', sans-serif;
          font-weight: 800;
          font-size: 18px;
          line-height: 30px;
          letter-spacing: 0;
          color: ${Colors.blackColor};
          text-decoration: underline;
          transition: all .3s ease;

          &:hover {
            color: ${Colors.purpleColor};
            transform: scale(1.05);
          }

          @media ${deviceMax.tablet} {
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }
  }
`;

export default SuccessStory;
